import React from "react";
import { UpgradeModal } from "features/Account/modules/UpgradeModal/UpgradeModal";
import { emailDripLearnMore } from "ui/pages/EmailDrip/pages/EmailDripReview/EmailDripReview.constants";

const DripUpgradeModal = ({ showUpgradeModal, setShowUpgradeModal }) => {
  return (
    <UpgradeModal
      isOpen={showUpgradeModal}
      message="Upgrade to &#8216;Premium&#8217; to create your drip!"
      description={
        <div>
          Setup custom drip email campaigns basis your customers&#8217;
          activity..{" "}
          <span
            className="tw-text-[#0052cc] !tw-cursor-pointer"
            onClick={() => window.open(emailDripLearnMore, "_blank")}
          >
            Learn more
          </span>
        </div>
      }
      setShowUpgradeModal={setShowUpgradeModal}
      btnText="Upgrade to Premium"
    />
  );
};

export default DripUpgradeModal;
